import defaultTheme from 'tailwindcss/defaultTheme'
import typography from '@tailwindcss/typography'

export default {
  plugins: [typography],
  content: [
    './components/**/*.{vue,js}',
    './layouts/**/*.vue',
    './pages/**/*.vue',
    './plugins/**/*.{js,ts}',
    './nuxt.config.{js,ts}'
  ],
  theme: {
    extend: {
      fontFamily: {
        sans: [ 'Montserrat', defaultTheme.fontFamily.sans ],
        afacad: ['Afacad', defaultTheme.fontFamily.sans],
        openSans:['Open Sans', defaultTheme.fontFamily.sans]
      },

      colors: {
        primary: '#fcf3df',
        secondary: '#5d3462',
        
        card: '#1a242d',
        input: '#0f1923',
        separator: '#e05840',

        bzRed: '#115e15',
        bzDarkRed: '#115e15a3',

        bzMenuTextLight: '#bcbfc7',
        bzMenuText: 'white',
        bzMenuTextDark: '#464d5e',

        //cores do site
        purple: "#692c61",
        beige: "#fcf3df",
        white: "#fafafa",
        coral: "#e05840",
        lilac: "#ad8fb0",
        black: "#000000",
        black: "#060606",
        green: "#69b28a",
        tagbg: "#D9D9D9",
        success: {
          DEFAULT: '#22c55e',
          hover: '#16a34a',
          light: '#f0fdf4',
          border: '#86efac',
          text: '#15803d',
        },
      },

       screens: {
        'moblg': '407px',
        'tablet': '640px',
        'laptop': '1024px',
        'desktop': '1280px',
    },

      backgroundImage: {
        'texture1': "url('/assets/texture.webp')",
      }

    }
  }
}